
import api from '../api'; // Import your configured axios instance


export const createEvaluationFile = async (evaluationFile, file) => {
  const formData = new FormData();
  formData.append('evaluationFile', new Blob([JSON.stringify(evaluationFile)], { type: 'application/json' }));
  formData.append('file', file);
  
  const response = await api.post('/evaluation-files/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// UPDATE evaluation file with optional file upload
export const updateEvaluationFile = async (id, evaluationFile, file = null) => {
  const formData = new FormData();
  formData.append('evaluationFile', new Blob([JSON.stringify(evaluationFile)], { type: 'application/json' }));
  if (file) {
    formData.append('file', file);
  }
  
  const response = await api.put(`/evaluation-files/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// DELETE evaluation file
export const deleteEvaluationFile = async (id) => {
  const response = await api.delete(`/evaluation-files/${id}`);
  return response.data;
};

// GET evaluation file by ID
export const getEvaluationFileById = async (id) => {
  const response = await api.get(`/evaluation-files/${id}`);
  return response.data;
};

// GET all evaluation files
export const getAllEvaluationFiles = async () => {
  const response = await api.get('/evaluation-files/');
  return response.data;
};

// GET evaluation files for a specific employee
export const getEmployeeEvaluationFiles = async (employeeId) => {
  const response = await api.get(`/evaluation-files/employee/${employeeId}`);
  return response.data;
};
export const getMyEvaluationFiles = async () => {
  try {
    const response = await api.get('/evaluation-files/me');
    console.log('My Evaluation Files response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching my evaluation files:', error);
    throw error;
  }
};